import FormDados from "pages/FormDados";
import Home from "pages/Home";
import Resumo from "pages/Resumo";
import Pagamento, { RetornoPagamento } from "pages/Pagamento";
import Sucesso from "pages/Sucesso";
import { Navigate, Route, Routes } from "react-router-dom";
import ContextRoute from "./ContextRoute";
import { PageUnavailableMessage } from 'components/PageUnavailableMessage'
import { getEnvVar } from "utils/environment";

const AppRoutes = () => {
  const maintenanceIsOn = getEnvVar('MAINTENANCE').toLowerCase() === "on"

  return (
    <Routes>
      {maintenanceIsOn ? (
        <>
          <Route
            path="*"
            element={<Navigate to="/unico" />}
          />
          <Route path="/unico" index element={<PageUnavailableMessage />} />
        </>
      ) : (
        <>
          <Route path="/unico" element={<Home />} />

          <Route
            path="/unico/resumo"
            element={
              <ContextRoute dependsOn="titleAmount">
                <Resumo />
              </ContextRoute>
            }
          />

          <Route
            path="/unico/dados-pessoais"
            element={
              <ContextRoute dependsOn="titleAmount">
                <FormDados />
              </ContextRoute>
            }
          />

          <Route
            path="/unico/pagamento"
            element={
              <ContextRoute dependsOn="proposta">
                <Pagamento />
              </ContextRoute>
            }
          />

          <Route
            path="/unico/retorno-pagamento"
            element={
              <ContextRoute dependsOn="proposta">
                <RetornoPagamento />
              </ContextRoute>
            }
          />

          <Route
            path="/unico/sucesso"
            element={
              <ContextRoute dependsOn="pagamento">
                <Sucesso />
              </ContextRoute>
            }
          />

          <Route path="*" element={<Navigate to="/unico" />} />
        </>
      )}
    </Routes>
  );
};

export default AppRoutes;
